import link from './fragment-link'

export default /* graphql */ `
fragment footerCTA on FooterCta {
  sys { id }
  title
  copy
  secondaryCopy
  link {
    ... on Link {
      ...link
    }
  }
  linkGtmClass
  backgroundImage {
    title
    url(transform: {
      width: 2160,
      height: 1440,
      resizeStrategy: THUMB,
      resizeFocus: CENTER,
      format: JPG,
      quality: 90
    }) 
  }
}
`
